import React from "react";
import { motion } from "framer-motion";

const Button = ({
  children,
  variant = "primary",
  size = "md",
  onClick,
  disabled = false,
  type = "button",
  className = "",
  icon,
  ...props
}) => {
  const variants = {
    primary: "bg-grad text-on-accent font-semibold shadow-glow hover:brightness-110 hover:-translate-y-px",
    secondary: "bg-panel border border-line2 text-ink hover:bg-hover",
    outline: "bg-transparent border border-accent-line text-accent-ink hover:bg-accent-soft",
    bordered: "bg-transparent border border-line2 text-muted hover:bg-hover hover:text-ink",
    danger: "bg-danger-soft text-danger hover:bg-danger/15",
    success: "bg-ok-soft text-ok hover:bg-ok/15",
    ghost: "bg-transparent text-muted hover:bg-hover hover:text-ink",
  };

  const sizes = {
    sm: "text-[13px] px-3 min-h-[36px]",
    md: "text-[14px] px-4 min-h-[40px]",
    lg: "text-[15px] px-6 min-h-[46px]",
  };

  const disabledClasses = disabled ? "opacity-50 cursor-not-allowed" : "";

  return (
    <motion.button
      type={type}
      onClick={onClick}
      disabled={disabled}
            whileTap={!disabled ? { scale: 0.98 } : {}}
      className={`inline-flex items-center justify-center gap-2 font-medium whitespace-nowrap rounded-xl transition-all duration-200 touch-manipulation ${variants[variant]} ${sizes[size]} ${disabledClasses} ${className}`}
      {...props}
    >
      {icon && <span>{icon}</span>}
      {children}
    </motion.button>
  );
};

export default Button;
